<template>
  <div class="home">
    <div class="card1">
      <div class="card1-t">
        <div class="card-left">
          <div class="card1-t1">数据，铸就非凡差异</div>
          <div class="card1-t2">Make Data Your Differentiator</div>
          <div class="card1-t3">
            闽江智能数据标注产业基地由闽清县产业投资有限公司与中启联信科技集团共同打造，构建“标注服务+人才培养+产业孵化”三位一体的官方数据智能创新平台。我们灵活的服务与深厚的专业知识，是铸就非凡的基础模型和企业级人工智能应用程序的基石。
          </div>
        </div>
        <div class="card1-right">
          <div style="margin-top: -250px;margin-right: 20px;">
            <swiper :options="swiperOptions">
              <swiper-slide
                style="width: 292px;height: 340px; margin: 10px 0;"
                v-for="(item, index) in cardList1"
                :key="index"
              >
                <img
                  style="width: 292px;height: 340px;position: relative;"
                  :src="item.img"
                  alt=""
                />
                <div class="card1-right-t">{{ item.text }}</div>
              </swiper-slide>
              <!-- 更多滑块 -->
            </swiper>
          </div>
          <div>
            <swiper :options="swiperOptions">
              <swiper-slide
                style="width: 292px;height: 340px; margin: 10px 0;"
                v-for="(item, index) in cardList2"
                :key="index"
              >
                <img
                  style="width: 292px;height: 340px;position: relative;"
                  :src="item.img"
                  alt=""
                />
                <div class="card1-right-t">{{ item.text }}</div>
              </swiper-slide>
              <!-- 更多滑块 -->
            </swiper>
          </div>
        </div>
      </div>
    </div>
    <div class="card2">
      <img
        style="width: 100%;margin: 60px 0;"
        src="../assets/img/home/line.webp"
        alt=""
      />
      <div class="flexs">
        <div>
          <img
            style="width: 616px;border-radius: 10px;"
            src="../assets/img/home/9.webp"
            alt=""
          />
        </div>
        <div style="width: 600px;">
          <div class="card2-t1">
            我们将致力于通过人机结合的方式为企业解决AI数据需求
          </div>
          <div class="card2-t2">
            据Gartner预计，到2026年，80%的企业将使用生成式AI，API或模型。然而，生成式AI应用的效果，需要高质量的数据及不断的测试加以保障。
          </div>
          <div class="card2-t2">
            我们将优化向客户提供深度学习服务的交付流程，通过人类反馈支持生成式AI模型的构建，并通过可定制、可审计的平台推动人工智能与人类的协作，创建高效、高质量的数据及反馈支持，助力企业大规模部署大模型。
          </div>
          <div class="btns" @click="go('/callMe')">
            了解大模型数据服务
          </div>
        </div>
      </div>
    </div>
    <div class="card3">
      <div class="card3-content">
        <div class="card3-t1">六年数据领域深耕，服务全国客户</div>
        <div class="logo-list">
          <div class="logo-item">
            <img style="width: 100%;" src="../assets/img/jys/1.png" alt="" />
          </div>
          <div class="logo-item">
            <img style="width: 100%;" src="../assets/img/jys/2.png" alt="" />
          </div>
          <div class="logo-item">
            <img style="width: 100%;" src="../assets/img/jys/3.png" alt="" />
          </div>
          <div class="logo-item">
            <img style="width: 100%;" src="../assets/img/jys/4.png" alt="" />
          </div>
          <div class="logo-item">
            <img style="width: 100%;" src="../assets/img/jys/5.png" alt="" />
          </div>
          <div class="logo-item">
            <img style="width: 100%;" src="../assets/img/jys/6.png" alt="" />
          </div>
          <div class="logo-item">
            <img style="width: 100%;" src="../assets/img/jys/7.png" alt="" />
          </div>
          <div class="logo-item">
            <img style="width: 100%;" src="../assets/img/jys/8.png" alt="" />
          </div>
          <div class="logo-item">
            <img style="width: 100%;" src="../assets/img/jys/9.png" alt="" />
          </div>
          <div class="logo-item">
            <img style="width: 100%;" src="../assets/img/jys/10.png" alt="" />
          </div>
          <div class="logo-item">
            <img style="width: 100%;" src="../assets/img/jys/11.png" alt="" />
          </div>
        </div>
        <div class="logo-list1">
          <div class="logo-item">
            <img style="width: 100%;" src="../assets/img/jys/1.png" alt="" />
          </div>
          <div class="logo-item">
            <img style="width: 100%;" src="../assets/img/jys/2.png" alt="" />
          </div>
          <div class="logo-item">
            <img style="width: 100%;" src="../assets/img/jys/3.png" alt="" />
          </div>
          <div class="logo-item">
            <img style="width: 100%;" src="../assets/img/jys/4.png" alt="" />
          </div>
          <div class="logo-item">
            <img style="width: 100%;" src="../assets/img/jys/5.png" alt="" />
          </div>
          <div class="logo-item">
            <img style="width: 100%;" src="../assets/img/jys/6.png" alt="" />
          </div>
          <div class="logo-item">
            <img style="width: 100%;" src="../assets/img/jys/7.png" alt="" />
          </div>
          <div class="logo-item">
            <img style="width: 100%;" src="../assets/img/jys/8.png" alt="" />
          </div>
          <div class="logo-item">
            <img style="width: 100%;" src="../assets/img/jys/9.png" alt="" />
          </div>
          <div class="logo-item">
            <img style="width: 100%;" src="../assets/img/jys/10.png" alt="" />
          </div>
          <div class="logo-item">
            <img style="width: 100%;" src="../assets/img/jys/11.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="card4">
      <div class="card4-t1">大模型应用落地全面支持</div>
      <div class="card4-t2">
        无论您使用什么基础模型，算力支持与调优方式，均为您提供高效落地支持，快速将生成式
        AI 投入应用。
      </div>
      <img
        style="width: 1280px;margin-top: 48px;"
        src="../assets/img/home/10.png"
      />
    </div>
    <div class="card4">
      <div class="card4-t1">深度学习的全流程数据支持</div>
      <div class="card4-t2">
        我们注重于深耕AI数据领域，我们的数据标注平台、专家团队及丰富的众包资源为您提供企业级的高质量数据服务。
      </div>
      <div class="flexs" style="margin-top: 48px;align-items: normal;">
        <div style="width: 600px;height: 400px;">
          <div class="card4-t3">数据标注</div>
          <div class="select-tab" style="width: 450px;">
            <div
              class="s-tabs"
              :class="tabIsactive == index ? 'is-active' : ''"
              v-for="(item, index) in tablist"
              :key="index"
              @click="tabIsactive = index"
            >
              {{ item.name }}
            </div>
          </div>
          <div
            style="text-align: left;white-space: pre-line;line-height: 1.5;font-size: 16px;"
          >
            {{ tablist[tabIsactive].content }}
          </div>
          <div class="btns" @click="go('/callMe')">了解服务详情</div>
        </div>
        <div style="width: 600px;padding-bottom: 40px;">
          <img
            style="width: 100%;border-radius: 8px;"
            :src="tablist[tabIsactive].img"
            alt=""
          />
        </div>
      </div>
      <div class="flexs" style="margin-top: 48px;align-items: normal;">
        <div style="width: 600px;padding-bottom: 40px;">
          <img
            style="width: 100%;border-radius: 8px;"
            src="../assets/img/home/11.webp"
            alt=""
          />
        </div>
        <div style="width: 600px;height: 400px;">
          <div class="card4-t3">数据采集</div>
          <div
            style="text-align: left;white-space: pre-line;line-height: 1.5;font-size: 16px;"
          >
            我们拥有众多众包团队，支持您的全球数据采集需求，针对细分AI应用场景进行数据定制。同时，平台支持大规模数据采集及数据清理、质量检测、预识别等，保证项目交付的质量和效率。
          </div>
          <div class="btns" @click="go('/callMe')">了解服务详情</div>
        </div>
      </div>
      <div class="flexs" style="margin-top: 48px;align-items: normal;">
        <div style="width: 600px;height: 500px;">
          <div class="card4-t3">成品数据集</div>
          <div
            style="text-align: left;white-space: pre-line;line-height: 1.5;font-size: 16px;"
          >
            提供700+成品数据集，包括ASR、文本、发音词典、图像及视频，为您的快速部署提供高质量数据支持。
          </div>
          <ul>
            <li
              style="text-align: left;white-space: pre-line;line-height: 1.5;font-size: 16px;margin-left: 15px;"
            >
              全球290+种语言及方言
            </li>
            <li
              style="text-align: left;white-space: pre-line;line-height: 1.5;font-size: 16px;margin-left: 15px;"
            >
              80+亿级别大模型数据集
            </li>
            <li
              style="text-align: left;white-space: pre-line;line-height: 1.5;font-size: 16px;margin-left: 15px;"
            >
              垂类数据：法律、医疗、教育等
            </li>
          </ul>
          <div class="btns" @click="go('/callMe')">了解服务详情</div>
        </div>
        <div style="width: 600px;padding-bottom: 40px;">
          <img
            style="width: 100%;border-radius: 8px;"
            src="../assets/img/home/12.webp"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="card4">
      <div class="card4-t1">支持您的多种AI应用场景</div>
      <div class="card4-t2">
        提供多垂类领域的数据服务，为您的AI应用场景提供准确、专业的数据支持。
      </div>
      <div class="flexs" style="flex-wrap: wrap;">
        <div class="item-card" v-for="(item, index) in cardList" :key="index">
          <img style="width: 48px;" :src="item.img" alt="" />
          <div style="font-size: 20px;margin:20px 0;color: #000;">
            {{ item.name }}
          </div>
          <div style="font-size: 16px;line-height: 1.5;color: #4b4f54;">
            {{ item.content }}
          </div>
        </div>
      </div>
    </div>
    <div class="card4">
      <div class="card4-t1" style="margin-top: 60px;">我们的服务优势</div>

      <div
        class="flexs"
        style="flex-wrap: wrap;align-items: center;justify-content: center;"
      >
        <div class="item-card2" v-for="(item, index) in cardList3" :key="index">
          <img style="width: 48px;" :src="item.img" alt="" />
          <div style="font-size: 20px;margin:20px 0;color: #000;">
            {{ item.name }}
          </div>
          <div style="font-size: 16px;line-height: 1.5;color: #4b4f54;">
            {{ item.content }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  components: { swiper, swiperSlide },
  data() {
    return {
      tabIsactive: 0,
      cardList3: [
        {
          name: "专家团队",
          content:
            "拥有超过28年的AI数据行业经验，为您的每一个项目注入专业见解。",
          img: require("../assets/img/home/f1.svg"),
        },
        {
          name: "大规模交付能力",
          content:
            "庞大的众包团队，专业的开发团队，经验丰富的项目经理，为快速交付大规模数据提供保障。",
          img: require("../assets/img/home/f2.svg"),
        },
        {
          name: "高质量数据",
          content:
            "通过了ISO27001,ISO9001与ISO27701，以及EHS证书，同时搭建了多个合规室/安全屋，为您的高安全要求提供支持。",
          img: require("../assets/img/home/f3.svg"),
        },
        {
          name: "快速响应",
          content:
            "以客户需求为核心，快速根据实际需求进行交付，包括数据支持、技术支持以及众包团队组建等。",
          img: require("../assets/img/home/f4.svg"),
        },
        {
          name: "持续创新",
          content:
            "针对市场与客户需求，持续进行前沿技术创新，为更高效、高质量的AI项目落地提供支持。",
          img: require("../assets/img/home/f5.svg"),
        },
      ],
      cardList: [
        {
          name: "智能驾驶",
          content:
            "提供自动驾驶以及智能驾舱的全面数据采集和标注服务，包括海外路采、语义分割、3D标注、4D标注、语音标注以及驾舱标注等，为您的智能驾驶提供高质量数据支持。",
          img: require("../assets/img/home/s1.svg"),
        },
        {
          name: "智慧医疗",
          content:
            "拥有专业的项目经理，支持您的医学大模型、辅助诊断系统、健康监测及专业数据库的数据采标需求，助力构建更加智能高效的智慧医疗AI系统。",
          img: require("../assets/img/home/s2.svg"),
        },
        {
          name: "企业出海",
          content:
            "拥有众多众包团队，以及290+种语言和方言，为您的企业出海AI，包括多语言智能客服、实地数据采集、应用本地化，以及多语言内容审核等提供数据支持。",
          img: require("../assets/img/home/s3.svg"),
        },
        {
          name: "互联网",
          content:
            "为您的互联网AI，包括虚拟数字人、内容审核、AR/VR、动画与游戏、身份认证（人脸，掌纹，虹膜等），以及配音生成等，提供数据采集与标注服务。",
          img: require("../assets/img/home/s4.svg"),
        },
        {
          name: "智能终端",
          content:
            "支持多种类智能终端，包括教育教辅、智能家居、智能安防、VR设备、无人机，以及工业机器人等应用的数据采标需求，支持您快速部署高质量智能终端AI。",
          img: require("../assets/img/home/s5.svg"),
        },
        {
          name: "新零售及电子商务",
          content:
            "提供无人商店、商品识图、智能客服大模型、语义搜索、AR换妆以及智能仓储物流等新零售及电子商务相关的AI数据支持，助推您的新零售及电子商务AI化进程。",
          img: require("../assets/img/home/s6.svg"),
        },
      ],
      tablist: [
        {
          name: "2D",
          content:
            "闽江智能数据标注产业基地提供全面的数据标注服务，包括大模型、图像视频、3D标注、4D标注、多语言文本语音标注，以及内容相关性标注。\n闽江智能数据标注产业基地数据标注平台涵盖多种标注工具套组、项目管理、工作流、AI辅助标注等，支持快速高效的数据标注交付。",
          img: require("../assets/img/home/2d.gif"),
        },
        {
          name: "3D",
          content:
            "闽江智能数据标注产业基地提供全面的数据标注服务，包括大模型、图像视频、3D标注、4D标注、多语言文本语音标注，以及内容相关性标注。\n闽江智能数据标注产业基地数据标注平台涵盖多种标注工具套组、项目管理、工作流、AI辅助标注等，支持快速高效的数据标注交付。",
          img: require("../assets/img/home/3d.gif"),
        },
        {
          name: "4D",
          content:
            "闽江智能数据标注产业基地提供全面的数据标注服务，包括大模型、图像视频、3D标注、4D标注、多语言文本语音标注，以及内容相关性标注。\n闽江智能数据标注产业基地数据标注平台涵盖多种标注工具套组、项目管理、工作流、AI辅助标注等，支持快速高效的数据标注交付。",
          img: require("../assets/img/home/4d.gif"),
        },
        {
          name: "文本",
          content:
            "闽江智能数据标注产业基地提供全面的数据标注服务，包括大模型、图像视频、3D标注、4D标注、多语言文本语音标注，以及内容相关性标注。\n闽江智能数据标注产业基地数据标注平台涵盖多种标注工具套组、项目管理、工作流、AI辅助标注等，支持快速高效的数据标注交付。",
          img: require("../assets/img/home/wb.webp"),
        },
        {
          name: "语音",
          content:
            "闽江智能数据标注产业基地提供全面的数据标注服务，包括大模型、图像视频、3D标注、4D标注、多语言文本语音标注，以及内容相关性标注。\n闽江智能数据标注产业基地数据标注平台涵盖多种标注工具套组、项目管理、工作流、AI辅助标注等，支持快速高效的数据标注交付。",
          img: require("../assets/img/home/yy.gif"),
        },
      ],
      cardList1: [
        { text: "Red Teaming", img: require("../assets/img/home/1.webp") },
        { text: "成品数据集", img: require("../assets/img/home/2.webp") },
        { text: "内容审核", img: require("../assets/img/home/3.webp") },
        { text: "搜索相关性", img: require("../assets/img/home/4.webp") },
      ],
      cardList2: [
        { text: "计算机视觉", img: require("../assets/img/home/5.webp") },
        { text: "大模型微调", img: require("../assets/img/home/6.webp") },
        { text: "RLHF", img: require("../assets/img/home/7.webp") },
        { text: "多模态", img: require("../assets/img/home/8.webp") },
      ],
      swiperOptions: {
        direction: "vertical",
        height: 360,
        loop: true, // 循环轮播
        loopAdditionalSlides: 100,
        speed: 7000,
        freeMode: true,
        freeModeMomentum: false,
        autoplay: {
          // 自动播放参数设置
          delay: 0, // 轮播时间间隔
          disableOnInteraction: false, // 用户操作后是否停止自动轮播，设为false表示不停顿
        },
        // 其他选项...
      },
    };
  },
  methods: {
    go(path) {
      this.$router.push(path);
    },
  },
};
</script>
<style lang="scss" scoped>
.home {
  background-color: #fff;
  .flexs {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .card4 {
    width: 1280px;
    margin: 48px auto;
    text-align: center;
    .item-card2 {
      flex-shrink: 0;
      text-align: center;
      width: 340px;
      margin: 40px 30px;
    }
    .item-card {
      flex-shrink: 0;
      padding: 40px 24px;
      background-color: #eceff0;
      border-radius: 8px;
      width: 360px;
      margin-top: 20px;
      text-align: left;
    }
    .select-tab {
      margin: 30px 0 20px;
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 38px;
      line-height: 38px;
      align-content: center;
      padding: 2px;
      border-radius: 25px;
      border-width: 1px;
      border-style: solid;
      border-color: #000;
      border-image: initial;
      .s-tabs {
        width: 20%;
        height: 38px;
        text-align: center;
        cursor: pointer;
        border-radius: 25px;
      }
      .is-active {
        color: rgb(255, 255, 255);
        background: #045588;
      }
    }
    .card4-t1 {
      color: #045588;
      font-size: 48px;
      font-weight: bold;
    }
    .card4-t2 {
      font-size: 16px;
      width: 680px;
      margin: 24px auto 0;
      line-height: 1.5;
    }
    .card4-t3 {
      font-size: 32px;
      text-align: left;
      margin-bottom: 56px;
      color: #045588;
      font-weight: bold;
    }
    .btns {
      cursor: pointer;
      margin-top: 32px;
      width: 150px;
      background-color: #099fee;
      color: #fff;
      height: 48px;
      line-height: 48px;
      padding: 0 20px;
      border-radius: 8px;
    }
  }
  .card3 {
    overflow: hidden;
    margin-top: 48px;
    width: 100%;
    height: 340px;
    background-color: #f1f1f1;
    @keyframes scroll {
      0% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(-50%);
      } /* 根据需要调整百分比和值 */
    }
    @keyframes scroll1 {
      0% {
        transform: translateX(-50%);
      }
      100% {
        transform: translateX(0);
      } /* 根据需要调整百分比和值 */
    }
    .logo-list1 {
      margin: 20px auto;
      display: flex;
      animation: scroll1 10s linear infinite;
      .logo-item {
        flex-shrink: 0;
        margin-right: 20px;
        width: 250px;
        // height: 80px;
        padding: 10px;
        display: flex;
        align-items: center;
        border-radius: 5px;
      }
    }
    .logo-list {
      margin: 20px auto;
      display: flex;
      animation: scroll 10s linear infinite;
      .logo-item {
        flex-shrink: 0;
        margin-right: 20px;
        width: 250px;
        // height: 80px;
        padding: 10px;
        display: flex;
        align-items: center;
        border-radius: 5px;
      }
    }
    .card3-content {
      width: 1280px;
      margin: 0 auto;
      .card3-t1 {
        color: #045588;
        font-size: 24px;
        text-align: center;
        padding-top: 48px;
      }
    }
  }
  .card2 {
    width: 1280px;
    margin: 0 auto;
    .card2-t1 {
      color: #045588;
      font-size: 32px;
      margin-bottom: 32px;
    }
    .card-t2 {
      font-size: 16px;
      line-height: 1.5;
      color: #4b4f54;
    }
    .btns {
      cursor: pointer;
      margin-top: 32px;
      width: 220px;
      background-color: #099fee;
      color: #fff;
      height: 48px;
      line-height: 48px;
      text-align: center;
      padding: 0 20px;
      border-radius: 8px;
    }
  }
  .card1 {
    height: 800px;
    background-image: linear-gradient(72deg, #7cd0ff54 7.43%, #f0efea 88.33%);
    .card1-t {
      width: 1280px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;
      .card-left {
        width: 600px;
        height: 800px;
      }
      .card1-right {
        width: 600px;
        height: 800px;
        display: flex;
        .card1-right-t {
          position: absolute;
          bottom: 20px;
          left: 0;
          width: 100%;
          height: 30px;
          background-color: rgba(0, 0, 0, 0.5);
          color: #fff;
          line-height: 30px;
          padding-left: 10px;
        }
      }
      .card1-t1 {
        margin: 200px 0 20px 0;
        font-size: 56px;
        font-weight: bold;
        color: #045588;
      }
      .card1-t2 {
        font-size: 32px;
        color: #4b4f54;
        margin-bottom: 20px;
      }
      .card1-t3 {
        font-size: 20px;
        color: #4b4f54;
        white-space: pre-line;
        line-height: 1.5;
        text-wrap-mode: wrap;
      }
    }
  }
}
</style>
